import { render, staticRenderFns } from "./SupplyRatioQuery.vue?vue&type=template&id=ba9366fc"
import script from "./SupplyRatioQuery.vue?vue&type=script&lang=js"
export * from "./SupplyRatioQuery.vue?vue&type=script&lang=js"
import style0 from "./SupplyRatioQuery.vue?vue&type=style&index=0&id=ba9366fc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports